import React from 'react'
import styles from './style'
import injectSheet from 'react-jss'
import numeral from 'numeral'
import tippy from 'tippy.js'
import firstCamerasManufacturer from 'helpers/firstCamerasManufacturer'

class CalculatorModel extends React.Component {
  componentDidMount = _ => {
    if (!this.props.currentCamera.imagerId) {
      [this.refs.cameraName, this.refs.selectModelButton]
        .forEach(ref =>
          tippy(ref, { duration: 0, theme: 'topbar', dynamicTitle: true })
        )
    }
  }

  cameraModelCountDisplay = _ => {
    const { manufacturerSpecificCameraModels, cameraModelCount, currentCamera: { imagerId } } = this.props

    if (imagerId) return 'Change Imager'

    return manufacturerSpecificCameraModels
      ? `Select from ${numeral(manufacturerSpecificCameraModels.length).format('0,0')} ${firstCamerasManufacturer(manufacturerSpecificCameraModels)} cameras`
      : `Select from ${numeral(cameraModelCount).format('0,0')} cameras`
  }

  render() {
    const { props: { manufacturerSpecificCameraModels,
      uiAction, lensModels, currentCamera: { model, imagerId }, classes } } = this

    return (
      <div className={classes.CalculatorModel}>
        <div className={classes.label}>Model</div>
        { !imagerId || lensModels.length > 1 || (lensModels.length === 1 && lensModels[0].aovs.length > 1)
          ? <div onClick={uiAction} className={classes.modelLinkContainer}>
              <a
                className={classes.modelLink}
                ref='cameraName'
                title={this.cameraModelCountDisplay()}
              >
                {model ? model.name : 'Generic Camera'}
              </a>
              <div
                className={classes.selectCameraLink}
                ref='selectModelButton'
                title={this.cameraModelCountDisplay()}
              >
                {
                  manufacturerSpecificCameraModels
                  ? `Select ${firstCamerasManufacturer(manufacturerSpecificCameraModels)} Models`
                  : (imagerId ? 'Change Imager' : 'Select Model')
                }
              </div>
            </div>
          : <div className={classes.noSelect}>{model ? model.name : 'Generic Camera'}</div>
        }
      </div>
    )
  }
}

export default injectSheet(styles)(CalculatorModel)



// WEBPACK FOOTER //
// ./src/components/GeneralPanelContainer/CalculatorModel/index.js